$(document).ready(function() {
  $('.five-img-slider').slick({
      dots: true,
      arrows:false,
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 500,
      slidesToShow: 1,
       prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0804/3298/8457/files/Left_arrow.svg?v=1717677942'></button>",
       nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0804/3298/8457/files/Right_Arrow.svg?v=1717677942'></button>",
      adaptiveHeight: true
    });
  var prevScrollpos = $(window).scrollTop();
  var $headerDiv = $(".header-wrapper");
  var headerBottom = $headerDiv.offset().top + $headerDiv.outerHeight();
  if ($('body').hasClass('index-page') && $(window).scrollTop() === 0) {
     $('.header-wrapper').addClass('top-page');
  }
  $(window).on("scroll", function() {
    var currentScrollPos = $(window).scrollTop();
    if (prevScrollpos > currentScrollPos || currentScrollPos < headerBottom) {
      $headerDiv.addClass("upscrolled");
      $headerDiv.removeClass("scrolled");
    } else {
      $headerDiv.removeClass("upscrolled");
      $headerDiv.addClass("scrolled");
    }
    prevScrollpos = currentScrollPos;
    if (currentScrollPos === 0) {
        $headerDiv.removeClass("scrolled");
        $headerDiv.removeClass("upscrolled");
    }
     if ($('body').hasClass('index-page') && $(window).scrollTop() === 0) {
     $('.header-wrapper').addClass('top-page');
  }
  });
  $('.mega-menu').on('toggle', function() {
      if ($(this).prop('open')) {
         $('.header-wrapper').addClass('open-mega');
      } else {
         $('.header-wrapper').removeClass('open-mega');
      }
    });
  $(document).on('click', function(event) {
      var $details = $('.mega-menu');
      if ($details.prop('open') && !$details.is(event.target) && $details.has(event.target).length === 0) {
        $details.removeAttr('open');
        $('.header-wrapper').removeClass('open-mega');
      }
    });

  $('.available-products .not-available-product').hide();
  $(".js-load-more").on("click", function () {
    var $this = $(this),
    totalPages = parseInt($("[data-all-pages]").val()),
    currentPage = parseInt($("[data-this-page]").val()),
    datacollurl = $("[data-coll-url]").val();
    $this.attr("disabled", true);
    $this.find("[load-more-text]").addClass("hide");
    $this.find("[loader]").removeClass("hide");
    var nextUrl = $("[data-next-link]").val();
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;
    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        $("[data-next-link]").val(datacollurl + "?page=" + next_coll);
        $("[data-this-page]").val(current_page_new);
        $(".available-products").append(
          $(responseHTML).find(".available-products").html()
        );
         $('.available-products .not-available-product').hide();
      },
      complete: function () {
        if (current_page_new < totalPages) {
          $this.attr("disabled", false);
          $this.find("[load-more-text]").removeClass("hide");
          $this.find("[loader]").addClass("hide");
        }
        if (current_page_new >= totalPages) {
          $(".available-products .not-available-product").appendTo(".available-products");
          $('.available-products .not-available-product').show();
          $this
            .find("[load-more-text]")
            .text("No More Products")
            .removeClass("hide");
          $this.find("[loader]").addClass("hide");
        }
      },
    });
  });
  
});
$(document).ready(function() {
            var firstLi = $(".mega-menu__list > li a").first();
            var secondLi = $(".mega-menu__list > li a").eq(1);
            var lastSegment="";
            if (firstLi.find(".mega-menu__link").hasClass("mega-menu__link--active")) {
              lastSegment =  firstLi.find(".mega-menu__link.mega-menu__link--active").text().trim();
            } else if (secondLi.find(".mega-menu__link").hasClass("mega-menu__link--active")) {
              lastSegment =  secondLi.find(".mega-menu__link.mega-menu__link--active").text().trim();
            }
             else
            {
             
               lastSegment =  $(".mega-menu__list > li a").first().text().trim();
           
            }
             lastSegment = lastSegment.toLowerCase().replace(/\s+/g, '-');

            var defaultmenuClass = 'menu-' + lastSegment;

            $('.' + defaultmenuClass).show();



  
      $('.initial-mega').show();
      // Preview squares are now static per dropdown (do not swap when hovering individual sub-links).
      // Previously this bound a hover handler on 'a.mega-menu__link' that hid all '.megamenu-img-inner'
      // and showed only the set matching the hovered sub-link's text. Disabled per request so the
      // top preview images always stay the dropdown's own default set.
});
$(document).ready(function() {
    $('.header').on('mouseleave', function() {
        $('.mega-menu').removeAttr('open');
        $('.header__menu-item').attr('aria-expanded', 'false');
    });


 $('#NewsletterForm--footer').on('blur', function() {
        if ($(this).val().length > 0) {
            $(this).closest('.field').addClass('inputvalue');
        } else {
            $(this).closest('.field').removeClass('inputvalue');
        }
    });


  
});
$(document).on("click", ".product-customizer-content .product-customizer-option > label", function(event) {
    $(this).closest('.product-customizer-option').find('div').first().toggleClass('expend');
    $(this).closest('.product-customizer-option').toggleClass('expended');
  
});
$('.js-blog-load-more').on('click', function(){
 var $this =$(this),
 totalPages = parseInt($('[data-all-pages]').val()),
 currentPage = parseInt($('[data-this-page]').val()),
 datacollurl = $('[data-coll-url]').val();;
 $this.attr('disabled', true);
 $this.find('[load-more-text]').addClass('hide');
 $this.find('[loader]').removeClass('hide');
 var nextUrl = $('[data-next-link]').val();
 var current_page_new = currentPage + 1;
 var next_coll = currentPage + 2;
 $.ajax({
 url: nextUrl,
 type: 'GET',
 dataType: 'html',
 success: function(responseHTML){
 $('[data-next-link]').val(datacollurl + "?page="+next_coll);
 $('[data-this-page]').val(current_page_new);
 $('.blog-articles').append($(responseHTML).find('.blog-articles').html());
 },
 complete: function() {
 if(current_page_new < totalPages) {
 $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
 } 
 if(current_page_new >= totalPages) {
 $this.find('[load-more-text]').text('No More Post').removeClass('hide'); $this.find('[loader]').addClass('hide');
 } 
 }
 })
});



function escapeClassName(className) {
    return className.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
  }



$(document).ready(function(){
  
   $('.scroll-container .horizontal-list').slick({      
              slidesToShow:$('.scroll-container .horizontal-list').data('size'),
              slidesToScroll: 1,
              arrows: true,
              infinite: true,
              prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0609/1161/6205/files/pre-arrow_9690cd0d-68e1-43ad-9c20-2287ccf2a4b1.svg?v=1726813684'>",
              nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0609/1161/6205/files/next-arrow_e227295a-b1a8-472a-b7c9-185ff54b6675.svg?v=1726813694'>",
              responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                      }
                    }
                   
                  ]
          });

   $('.blog-scroll-container .blog-horizontal-list').slick({      
              slidesToShow: 6,
              slidesToScroll: 1,
              arrows: true,
              infinite: true,
              prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0609/1161/6205/files/pre-arrow_9690cd0d-68e1-43ad-9c20-2287ccf2a4b1.svg?v=1726813684'>",
              nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0609/1161/6205/files/next-arrow_e227295a-b1a8-472a-b7c9-185ff54b6675.svg?v=1726813694'>",
              responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                      }
                    }
                   
                  ]
          });
  
});

$(document).ready(function(){

 // Function to convert labels and spans into an accordion
    function makeAccordion() {
        $('.webyze-ilpo-option').each(function() {
            $(this).find('label').not('.webyze-accordion-initialized').each(function() {
                var label = $(this);
                var content = label.nextAll('span').first();
                label.addClass('webyze-accordion webyze-accordion-initialized');
                content.addClass('webyze-accordion-content');
                content.hide();
                label.click(function() {
                    content.slideToggle();
                    label.toggleClass('active');
                });
            });
        });


    // var cutElement = $('.webyze-ilpo-preview-wrapper').remove();
    // var newInnerDiv = $('<div class="left-side-img-inner"></div>').append(cutElement);
    // newInnerDiv.prependTo('.left-side-img-wrap');



      
    }

    // Wait for the form to be loaded and then create the accordion
    function waitForForm() {
        var checkInterval = setInterval(function() {
            if ($('.webyze-infinitelivepreviewoptions-form').length > 0) {
              setTimeout(
                function() 
                {
                              clearInterval(checkInterval);
                              makeAccordion();
                }, 500);
                
            }
        }, 500);
    }

    waitForForm();



setTimeout( function(){ 
    if ($('.product-recommendations ul').length > 0) {
        $('.product-recommendations ul').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: 720, // Mobile breakpoint
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
                {
                    breakpoint: 9999, // Disable Slick on larger screens
                    settings: "unslick" // Disable Slick on larger screens
                }
            ]
        });
    }
  }  , 3000 );


const localData2 = localStorage.getItem("recentlyViewedProduct");
 let productList2 = [];

  if (localData2 !== null) {
    productList2 = JSON.parse(localData2);
  }



  
if (productList2.length > 3) {
var checkInterval = setInterval(function() {
    // Check if .recently-viewed-wrapper ul exists in the DOM
    if ($('.recently-viewed-wrapper ul').length) {
      // Initialize the Slick slider
      $('.recently-viewed-wrapper ul').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        responsive: [
          {
            breakpoint: 720, // Mobile breakpoint
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
             
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
          {
            breakpoint: 9999, // Disable Slick on larger screens
            settings: "unslick" // Disable Slick on larger screens
          }
        ]
      });
      // Clear the interval once the slider is initialized
      clearInterval(checkInterval);
    }
  }, 500);
}  




 setTimeout(function() {
$('input[name="Color"]').change(function() {
      var selectedMediaId = $(this).data('media-id');
  console.log(selectedMediaId);
      var targetImage = $('.left-side-img-inner[data-media-id="' + selectedMediaId + '"]');
      targetImage.prependTo('.left-side-img-wrap');
});
$('input[name="Color"]:checked').trigger('change');
 }, 1000);



  




$("ul.main-blog-sort").on("click", ".init", function() {
    $(this).closest("ul").children('li:not(.init)').toggle();
});

var allOptions = $("ul.main-blog-sort").children('li:not(.init)');
$("ul.main-blog-sort").on("click", "li:not(.init)", function() {
    allOptions.removeClass('selected');
    $(this).addClass('selected');
    $("ul.main-blog-sort").children('.init').html($(this).html());
    allOptions.toggle();

    // Get the selected data value
    var selectedSort = $(this).data('value');

    // Show/Hide the corresponding blog sort divs
    $(".blog-sort").hide(); // Hide all sort divs
    $(".blog-sort[data-sort='" + selectedSort + "']").show(); // Show the selected one
});

  
  
  

});